'use strict';
var UA = require('../internals/environment-user-agent');

module.exports = /MSIE|Trident/.test(UA);



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/internals/environment-is-ie-or-edge.js
// module id = 386
// module chunks = 0